import { assetsActions, deviceStatusInfo,site, assetsSetWifi, assetsReboot, assetsSetApn, assetsSetCpin, assetsDelete ,assetsUpgrade,walktestTestMap,
  adminStatus,telemetryPopupAction, walktest, walktestActions, walktestSettings, walktestSettingsAction, 
  deviceStatus,walktestOpenDeviceStatus, disableActionsAction,walktestDisableOptions,selctMapOnLiveAction, launchTestAction, launchTestString, reloadActionsData, reloadingActions,
  assetsCommandPrompt,userActions, userData,deviceDetailsActions,openDeviceDataString,gpsReportAction,
  assetsadvnceConfig} from "./act.action";

export let mapname:string = undefined
export let reload = {};
// export const assetsHeader: any = {
//   addDevice: false,
//   setWifi: false,
//   reboot:false,
//   setApn:false,
//   delete:false,
//   upgrade: false,
//   adminStatus:false,
//   modeStatus:false,
//   telemetryPopup:false,
//   setPrompt:false,
//   telemetryData:{enabled:"false", interval:0},
// };
export const wifi = {setWifi: false};
export const advnceConfig = {advnceConfig: false};
export const reboot = {reboot:false};
export const apn = {setApn:false};
export const cpin = {setCpin:false};
export const upgrade = {upgrade: false};
// export const mode = {modeStatus:false};
export const telemetry = {telemetryPopup:false};
export const prompt = {setPrompt:false};
export const telemetrydata={telemetryData:{enabled:"false", interval:0}};
export const addDevice = {addDevice: false};
export const deleteDevice = {delete:false}
export const admin = {adminStatus:false, modeStatus:false}

const devicePopup = false;
export const user = {};

export const launchTestData:any={
mapdata:[],
devicedata:[],
locname:''
}

export const walktestInit:any = {
  showStartTest:false,
  showStopTest : false
 
}
export const walktestSettingsInit:any={
  openSettings:false,
  params:{}
}
export const walktestDevcieStatusInit:any={
  showDeviceStatus:false
}

export const walktestOngoingTestInit:any={
  showOngoingTests:false
}

export const disableActionsInit:any={
  disableActions:false
}

export const dep: any = { deploymentId: '' };
export const depList: any = { deploymentList: [] };

export function deviceDatailsReducer(state=devicePopup, action:deviceDetailsActions){
  switch (action.type){
    case openDeviceDataString:
      return action?.data;
    default:
        return state;
  }
}

export function userReducer(state = user, action:userActions){
  switch (action.type){
    case userData:
      return action?.data;
      default:
      return state;
  }
}

export function reLoadActionsDataReducer(state=reload, action: reloadActionsData){
  switch (action.type){
    case reloadingActions:
      return action?.data;
      default:
        return state;
  }

}

export function assetCreate(state = addDevice, action: assetsActions) {
  switch (action.type) {
    case site:
      return { ...state,  addDevice : action.data.addDevice };
    default:
      return state;
  }
}
export function openStatusPopUP(state = addDevice, action: deviceStatusInfo) {
  switch (action.type) {
    case site:
      return { ...state,  opePopUp : action.data.opePopUp };
    default:
      return state;
  }
}
export function assetsetWifi(state = wifi, action: assetsSetWifi) {
  switch (action.type) {
    case site:
      return { ...state,  setWifi:action.data.setWifi };
    default:
      return state;
  }
}
export function assetadvnceConfig(state = advnceConfig, action: assetsadvnceConfig) {
  switch (action.type) {
    case site:
      return { ...state,  advnceConfig:action.data.advnceConfig };
    default:
      return state;
  }
}

export function assetPrompt(state=prompt, action:assetsCommandPrompt){
  switch(action.type){
    case site:
      return {...state, setPrompt:action.data.setPrompt};
      default:
        return state;
  }

}
export function assetReboot(state = reboot, action: assetsReboot) {
  switch (action.type) {
    case site:
      return { ...state,  reboot:action.data.reboot };
    default:
      return state;
  }
}
export function assetsetApn(state = apn, action: assetsSetApn) {
  switch (action.type) {
    case site:
      return { ...state,  setApn:action.data.setApn };
    default:
      return state;
  }
}
export function assetsetCpin(state = cpin, action: assetsSetCpin) {
  switch (action.type) {
    case site:
      return { ...state,  setCpin:action.data.setCpin };
    default:
      return state;
  }
}
export function assetDelete(state = deleteDevice, action: assetsDelete) {
  switch (action.type) {
    case site:
      return { ...state,  delete :action.data.delete };
    default:
      return state;
  }
}
export function assetUpgrade(state = upgrade, action: assetsUpgrade) {
  switch (action.type) {
    case site:
      return { ...state,  upgrade :action.data.upgrade };
    default:
      return state;
  }
}

export function adminStateReducer(state = admin, action: adminStatus) {
  switch (action.type) {
    case site:
      return { ...state,  adminStatus : action.data.adminStatus, modeStatus:action?.data?.modeStatus};
    default:
      return state;
  }
}

export function telemetryStateReducer(state=telemetry, action:telemetryPopupAction){
  switch (action.type) {
    case site:
      return { ...state,  telemetryPopup : action.data.telemetryPopup, telemetryData:action.data.telemetryData };
    default:
      return state;
  }

}
export function gpsReportStateReducer(state=telemetry, action:gpsReportAction){
  switch (action.type) {
    case site:
      return { ...state,  loadReport : action.data.loadReport, };
    default:
      return state;
  }

}
export function walkTestStartTestReducer(state = walktestInit, action:walktestActions){
  switch(action.type){
    case walktest:
      return { ...state,  showStartTest : action.data.showStartTest, showStopTest : action.data?.showStopTest}
    default:
      return state;
  }
}

export function walkTestSettingsReducer(state = walktestSettingsInit, action:walktestSettingsAction){
  switch(action.type){
    case walktestSettings:
        return { ...state,  openSettings:action.data.openSettings, params:action.data.params?action.data.params:{}}
    default:
      return state;
  }
}

export function walktestDeviceStatusReducer(state = walktestDevcieStatusInit, action:walktestOpenDeviceStatus){
  switch(action.type){
    case deviceStatus:
        return { ...state,  showDeviceStatus:action.data.showDeviceStatus}
    default:
      return state;
  }
  
}

export function walktestOngoingTestsReducer(state = walktestOngoingTestInit, action:walktestOpenDeviceStatus){
  switch(action.type){
    case deviceStatus:
        return { ...state,  showOngoingTests:action.data.showOngoingTests}
    default:
      return state;
  }
  
}

export function disableButtonReducer(state= disableActionsInit, action:disableActionsAction){
  switch(action.type){
    case walktestDisableOptions:
        return { ...state,  disableActions:action.data.disableActions}
    default:
      return state;
  }
}

export function selecMapReducer(state = mapname, action:selctMapOnLiveAction){
  switch(action.type){
    case walktestTestMap:
     return action.mapname;
    default:
    return state  
  }

}

export function launchTestReducer(state = launchTestData, action:launchTestAction){
  switch(action.type){
    case launchTestString:
     return {...state, ...action?.launchData}
    default:
    return state  
  }

}